module.exports = __webpack_public_path__ + "static/img/nanoscience_3.3e378d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/nanoscience_3.png
// module id = 9SS5
// module chunks = 6